import { useSelector } from 'react-redux'
import { Outlet, Link } from 'react-router-dom'
import { MinimalHeader } from '@bosch/react-frok'
import type { LogoProps } from '@bosch/react-frok'

import Footer from '@/ui/components/Footer/Footer'

import { AuthorisationStates } from '@/constants'
import { RootState } from '@/utils/store/store'

import './IdentityLayout.scss'

// The logo renders as a router link: `to` is a prop of the link, not of the anchor that LogoProps describes
const logo: LogoProps & { to: string } = { as: Link, to: '/' }

const IdentityLayout = () => {
    const { darkTheme } = useSelector((state: RootState) => state.application)
    const { authorisationFlow } = useSelector((state: RootState) => state.authentication)
    const isAuthorizationInProgress =
        authorisationFlow === AuthorisationStates.AUTHORISING ||
        !!sessionStorage.getItem('isAuthorizationInProgress')

    return (
        <div className={`app -${darkTheme ? 'dark' : 'light'}-mode`}>
            <MinimalHeader logo={logo} />
            <div className="identity-layout-wrapper">
                <Outlet />
            </div>
            {!isAuthorizationInProgress && <Footer show={true} />}
        </div>
    )
}

export default IdentityLayout
